"use client";

import { useState, useEffect } from "react";
import { useAppContext } from "@components/Provider";

const ScrollArrow = () => {
  const { isMobile } = useAppContext();
  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 2000) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 2000) {
      setShowScroll(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", checkScrollTop);
    return () => window.removeEventListener("keyup", checkScrollTop);
  }, [showScroll]);

  return (
    <div
      className="scrollTop"
      style={{
        height: 40,
        display: showScroll ? "flex" : "none",
        justifyContent: "flex-end",
      }}
    >
      <span className="chevron top" onClick={scrollTop}>
        {isMobile ? "Top" : "Back to Top"}
      </span>
      <style jsx>
        {`
          .scrollTop {
            position: fixed;
            width: 100%;
            bottom: ${isMobile ? "7em" : "20px"};
            align-items: center;
            height: 20px;
            justify-content: center;
            z-index: 1000;
            right: 0px;
            font-size: ${isMobile ? "12px" : "16px"};
            font-weight: bold;
          }
          .scrollTop span {
            cursor: pointer;
            background: #e1e1e1;
            padding: 10px;
            margin-right: 10px;
            color: #666666;
            width: ${isMobile ? "59px" : "auto"};
            padding-top: ${isMobile ? "25px" : "0.5rem"};
            padding-left: ${isMobile ? "" : "15px"};
          }
          .chevron::before {
            border-style: solid;
            border-width: 0.25em 0.25em 0 0;
            content: "";
            display: inline-block;
            height: 0.45em;
            right: ${isMobile ? "-1.25em" : "0.35em"};
            position: relative;
            top: ${isMobile ? "-15px" : "0.40em"};
            transform: rotate(-45deg);
            vertical-align: top;
            width: 0.45em;
          }
        `}
      </style>
    </div>
  );
};

export default ScrollArrow;
